import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import AuthLayout from './AuthLayout';
import { AlertBox } from '../main/CommonStyles';
import { AppConfig } from '../config';
import CodeLoginForm from './CodeLoginForm';
import StandardLoginForm from './StandardLoginForm';

const ToggleViewLink = styled.button`
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.9rem;
    margin-top: 1.5rem;
    font-family: inherit;

    &:hover {
        color: ${({ theme }) => theme.colors.primaryDark};
    }
`;

const FooterLinkText = styled.p`
    text-align: center;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textMedium};
    margin-top: 1rem;
    a {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 600;
        text-decoration: none;
        &:hover { text-decoration: underline; }
    }
`;

const LoginPage = () => {
    // Domyślnie pokazujemy logowanie kodem, jeśli jest włączone w konfiguracji
    const [view, setView] = useState(AppConfig.auth.ENABLE_CODE_LOGIN ? 'code' : 'standard');
    const location = useLocation();
    const messageFromState = location.state?.message;

    const renderContent = () => {
        if (view === 'code') {
            return (
                <>
                    <CodeLoginForm />
                    <ToggleViewLink onClick={() => setView('standard')}>
                        Jesteś nauczycielem lub chcesz zalogować się inaczej?
                    </ToggleViewLink>
                </>
            );
        }

        if (view === 'standard') {
            return (
                <>
                    <StandardLoginForm initialError={messageFromState && !location.state?.from ? messageFromState : null} />
                    {AppConfig.auth.ENABLE_CODE_LOGIN && (
                        <ToggleViewLink onClick={() => setView('code')}>
                            Jesteś uczniem? Zaloguj się kodem.
                        </ToggleViewLink>
                    )}
                </>
            );
        }
        return null;
    };

    const title = view === 'code'
        ? (AppConfig.appName || 'Witaj!')
        : 'Zaloguj się';
    const subtitle = view === 'code'
        ? 'Wpisz kod, który otrzymałeś/aś w szkole.'
        : 'Witaj z powrotem!';

    return (
        <AuthLayout title={title} subtitle={subtitle}>
            {messageFromState && location.state?.from && (
                <AlertBox type="info" style={{ marginBottom: '1rem' }}>
                    {messageFromState}
                </AlertBox>
            )}
            {renderContent()}

            {AppConfig.auth.ENABLE_STANDARD_REGISTER && view === 'standard' && (
                <FooterLinkText>
                    Nie masz konta? <Link to="/register">Zarejestruj się</Link>
                </FooterLinkText>
            )}
        </AuthLayout>
    );
};

export default LoginPage;